import CreatorStudioSpeakerIdentificationModal from '@src/components/sidepanel/modals/CreatorStudioSpeakerIdentificationModal';
import { useSpeakerIdentificationPrompt } from '@src/hooks/useSpeakerIdentificationPrompt';
import { observer } from 'mobx-react-lite';

/**
 * Opens speaker identification for confirmation the first time a freshly
 * uploaded story is ready and open (see `useSpeakerIdentificationPrompt`).
 * Mounted by Content Studio and Creator Studio. It opens straight onto the
 * suggestions the background run computed during the upload; without one it
 * runs the analysis out of sight first. The modal broadcasts its own
 * speaker-cache events on apply, so any mounted Speakers panel refreshes
 * without wiring here, and the user stays where they are.
 */
const SpeakerIdentificationPrompt = observer(() => {
  const { prompt, onReady, close } = useSpeakerIdentificationPrompt();
  if (!prompt) return null;
  return (
    <CreatorStudioSpeakerIdentificationModal
      isOpen
      onClose={close}
      anonymousSpeakers={prompt.anonymousSpeakers}
      currentMappings={prompt.mappings}
      onIdentificationComplete={close}
      precomputed={prompt.precomputed}
      autoIdentify={!prompt.precomputed}
      onShown={onReady}
    />
  );
});

export default SpeakerIdentificationPrompt;
